import dayjs from 'dayjs'
let border = false
export default {
  namespaced: true,
  state: {
    tableAlign: 'left',
    pageSize: 20,
    tableSizes: [20, 50, 100, 200, 300],
    tableHeaderStyle: {
      background: '#FAFAFA',
      color: '#333333',
      fontWeight: 'bold'
    },
    colorList: [
      '#9E0142', '#D33C4F', '#F28E5B', '#E4A675', '#E6C281', '#AFA585', '#857499', '#7C4184',
      '#E37563', '#BA615C', '#FEBD70', '#F9E691', '#EDF098', '#BCE4A2', '#9579A1', '#7EA5B5',
      '#933F64', '#B74468', '#CFC39C', '#D38E78', '#8FC0AC', '#C1C09F', '#585FA9', '#4976B4'
    ],
    tableSexList: [
      {
        text: '男',
        value: 1
      },
      {
        text: '女',
        value: 2
      },
      {
        text: '暂无',
        value: -1
      }
    ],
    isHandoverTypeList: [// 移交类型
      {
        text: '全部',
        value: -1
      },
      {
        text: '跨分校',
        value: 0
      },
      {
        text: '跨系统',
        value: 1
      }
    ],
    isHandoverStateList: [
      {
        // 移交状态
        text: '待确认',
        value: 1
      },
      {
        text: '移交成功',
        value: 2
      },
      {
        text: '移交失败',
        value: 3
      }
    ],
    payStatusList: [
      {
        text: '支付成功',
        value: 1
      },
      {
        text: '支付失败',
        value: 0
      }
    ],
    costType: [
      {
        text: '物料',
        value: 1
      },
      {
        text: '代理',
        value: 2
      },
      {
        text: '其他',
        value: 3
      },
      {
        text: '资料',
        value: 4
      }
    ],
    courseAttributeList: [
      { text: '未报名', value: 0 },
      { text: '已报免费', value: 1 },
      { text: '已报低端', value: 2 },
      { text: '已报中端', value: 3 },
      { text: '已报高端', value: 4 },
      { text: '已报转赠', value: 5 }
    ],
    marketActive: {
      activeManege: {
        isBorder: border
      },
      opponentLecture: {
        isBorder: border
      },
      bookActivity: {
        isBorder: border
      }
    },
    isBorder: true,
    pickerOptions: {
      shortcuts: [
        {
          text: '昨日',
          onClick(picker) {
            const start = dayjs().subtract(1, 'day').startOf('day').toDate()
            const end = dayjs().subtract(1, 'day').endOf('day').toDate()
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '今日',
          onClick(picker) {
            const start = dayjs().startOf('day').toDate()
            const end = dayjs().endOf('day').toDate()
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '近7天',
          onClick(picker) {
            const start = dayjs().subtract(6, 'day').startOf('day').toDate()
            const end = dayjs().endOf('day').toDate()
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '近15天',
          onClick(picker) {
            const start = dayjs().subtract(14, 'day').startOf('day').toDate()
            const end = dayjs().endOf('day').toDate()
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '近30天',
          onClick(picker) {
            const start = dayjs().subtract(29, 'day').startOf('day').toDate()
            const end = dayjs().endOf('day').toDate()
            picker.$emit('pick', [start, end])
          }
        }]
    },
    pickerOptions1: {
      shortcuts: [
        {
          text: '昨日',
          onClick(picker) {
            const start = dayjs().subtract(1, 'day').startOf('day').toDate()
            const end = dayjs().subtract(1, 'day').endOf('day').toDate()
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '今日',
          onClick(picker) {
            const start = dayjs().startOf('day').toDate()
            const end = dayjs().endOf('day').toDate()
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '近7天',
          onClick(picker) {
            const start = dayjs().endOf('day').toDate()
            const end = dayjs().add(6, 'day').startOf('day').toDate()
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '近15天',
          onClick(picker) {
            const start = dayjs().endOf('day').toDate()
            const end = dayjs().add(14, 'day').startOf('day').toDate()
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '近30天',
          onClick(picker) {
            const start = dayjs().endOf('day').toDate()
            const end = dayjs().add(29, 'day').startOf('day').toDate()
            picker.$emit('pick', [start, end])
          }
        }]
    },
    // 基础数据
    basedata: {
      // 学科
      subjectManage: {
        isBorder: border
      },
      // 科目
      sourceManage: {
        isBorder: border
      },
      // 学科门类
      courseManage: {
        isBorder: border
      },
      purchase: {
        isBorder: border
      }
    },
    // 问卷管理
    questionManage: {
      questionType: {
        isBorder: border
      }
    }
  }
}
